import { AuthConfig } from 'angular-oauth2-oidc';

/**
 * Returns the OAuth configuration by reading from sessionStorage.
 * This function reads values at call time, ensuring they are available
 * after SessionConfigService has populated sessionStorage via APP_INITIALIZER.
 */
export function getAuthConfig(): AuthConfig {
  const requireHttpsValue = sessionStorage.getItem('requireHttps');
  
  return {
    issuer: sessionStorage.getItem('hydraFrontendServer'),

    redirectUri: sessionStorage.getItem('oAuthRedirectUrl'),

    logoutUrl: sessionStorage.getItem('oAuthLogoutUrl'),

    clientId: sessionStorage.getItem('hydraClient'),

    scope: 'openid offline',

    clearHashAfterLogin: false,

    showDebugInformation: true,

    oidc: true,

    requireHttps: requireHttpsValue ? JSON.parse(requireHttpsValue) : false,

    customQueryParams: {
      access_id: sessionStorage.getItem('accessId'),
      gt_user_token: new URLSearchParams(window.location.search).get('guid') || '',
      origin_user: new URLSearchParams(window.location.search).get('origin-subject') || ''
    },
  };
}

/**
 * @deprecated Use getAuthConfig() instead. This constant is kept for backward compatibility
 * but will have null values if accessed before SessionConfigService loads the config.
 */
export const authConfig: AuthConfig = getAuthConfig();






